import { Injectable, TemplateRef } from '@angular/core'
import { E11ModalGlobalService } from '@engineering11/ui-lib/e11-modal'
import { NextStep } from 'shared-lib'

@Injectable({
  providedIn: 'root',
})
export class ApplicationSubmissionModalService {
  private modalContent: TemplateRef<unknown> | undefined
  private nextSteps: NextStep[] = []

  constructor(private globalModalService: E11ModalGlobalService) {}

  open(nextSteps?: NextStep[]) {
    if (!this.modalContent) {
      return
    }

    if (nextSteps) {
      this.nextSteps = nextSteps
    }

    this.globalModalService.openModal({
      body: this.modalContent,
      bodyHeight: 'auto',
      showFooter: false,
      title: 'Application Submission',
      width: 'lg',
    })
  }

  getNextSteps(): NextStep[] {
    return this.nextSteps
  }

  set modalBody(content: TemplateRef<unknown>) {
    this.modalContent = content
  }
}
